export const GET_USERS = 'GET_USERS';
export const GET_USERS_SUCCESS = 'GET_USERS_SUCCESS';
export const GET_USERS_FAIL = 'GET_USERS_FAIL';

export const GET_USER_DETAIL = 'GET_USER_DETAIL';
export const GET_USER_DETAIL_SUCCESS = 'GET_USER_DETAIL_SUCCESS';
export const GET_USER_DETAIL_FAIL = 'GET_USER_DETAIL_FAIL';

export const DELETE_USER = 'DELETE_USER';
export const DELETE_MANY_USERS = 'DELETE_USERS';
export const DEACTIVATE_USER = 'DEACTIVATE_USER';
export const ACTIVATE_USER = 'ACTIVATE_USER';

export const SAVE_USER = 'SAVE_USER';
export const UPDATE_USER = 'UPDATE_USER';

export const GET_ACTIVE_QUESTIONNAIRES = 'GET_ACTIVE_QUESTIONNAIRES';
export const GET_ACTIVE_QUESTIONNAIRES_SUCCESS =
    'GET_ACTIVE_QUESTIONNAIRES_SUCCESS';
export const GET_ACTIVE_QUESTIONNAIRES_FAIL = 'GET_ACTIVE_QUESTIONNAIRES_FAIL';
